import base from '@/http/url_base';

export default {
  SOURCING_ACCES: base.API_ACHAT + '/sourcing-acces-fournisseurs',
  SOURCING_AUTORISE_ACCES:
    base.API_ACHAT + '/sourcing-acces-fournisseurs/autorise',
  SOURCING_BLOCK_ACCES: base.API_ACHAT + '/sourcing-acces-fournisseurs/block',
};
